import * as React from 'react';
import { TableProps } from 'semantic-ui-react';
import '../css/table.sass';

export default function Thead(props: TableProps) {
  const { className, ...other } = props; // eslint-disable-line @typescript-eslint/no-unused-vars
  return (
    <thead className="campfire-thead" {...other}>
      {props.children}
    </thead>
  );
}
